import { SubHeading } from '../common/subHeading';
import SuggestRelatedFundsNew from '../common/suggestRelatedFundsNew';

export const RelatedFunds = ({ isMobile, similarFunds }) => {
  return (
    <div className={`related-funds-block lil-mt-20 }`}>
      <div className=" sm:lil-w-full">
        <SubHeading title="Related Funds" />
        <SuggestRelatedFundsNew
          isMobile={isMobile}
          fundList={similarFunds.slice(0, 10)}
        />
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/singleFundNewCmp/relatedFunds.tsx